import { AnalyticsDonutChartController } from './donut-chart.controller'

function analyticsDonutChart () {
  return {
    restrict: 'E',
    scope: {
      name: '<',
      tooltip: '<',
      data: '<',
      isLastDonut: '<',
      periodStart: '<',
      periodEnd: '<',
      isArchived: '<',
      type: '@'
    },
    templateUrl: '/analytics/directives/analytics-data-frame-big-card-donut/components/donut-chart/donut-chart-directive.html?$$REVISION$$',
    controller: AnalyticsDonutChartController
  }
}

export { analyticsDonutChart }
